<template>
  <v-footer app :class="{ local: mode === 'local', dev: mode === 'dev', dxc: mode === 'dxc', sta: mode === 'sta' }">
    {{ displayName }}
    <div class="footer">
      &copy;
      <span class="d-none d-sm-inline-block"> Suzuki Motor Corporation </span>
    </div>
  </v-footer>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, toRefs } from 'vue';

export default defineComponent({
  name: 'AppFooter',
  setup() {
    const state = reactive({
      displayName: 'PXP Packing Planning',
      mode: 'local',
    });
    onMounted(() => {
      state.mode = import.meta.env.MODE || 'dev';
      state.mode = state.mode === 'development' ? 'dev' : state.mode;
      state.displayName = ['dev', 'dxc', 'sta'].includes(state.mode)
        ? '【' + state.mode.toUpperCase() + '】PXP Packing Planning'
        : 'PXP Packing Planning';
    });
    return {
      ...toRefs(state),
    };
  },
});
</script>

<style scoped lang="scss">
footer.v-footer {
  height: 40px;
  background: #0066cc;
  color: #ffffff;
}

div.footer {
  position: absolute;
  right: 16px;
}

footer.local {
  background: #0066cc;
}
footer.dev,
footer.dxc {
  background: #009688;
}
footer.sta {
  background: #e20a0a;
}
</style>
